export const inspectTable = [
  {
    id: 1,
    title: "1. 도급, 용역, 위탁 시 산업재해 예방 조치능력 평가",
    label: "입찰 공고문, 과업지시서, 계약서, 위탁협약서 등에 안전·보건 확보 의무사항 명시",
    is_checked: "",
    note: "",
  },
  {
    id: 2,
    title: "1. 도급, 용역, 위탁 시 산업재해 예방 조치능력 평가",
    label: "‘협상의 의한 계약 제안서’ 평가 시 안전·보건 확보 관련 내용 포함",
    is_checked: "",
    note: "",
  },
  {
    id: 3,
    title: "1. 도급, 용역, 위탁 시 산업재해 예방 조치능력 평가",
    label: "안전보건 확보 의무이행 서약서 징구(안전보건관리계획서)",
    is_checked: "",
    note: "",
  },
  {
    id: 4,
    title: "2. 도급, 용역, 위탁 시 종사자 안전·보건을 위한 관리비용 반영",
    label: "종사자 안전·보건 확보를 위한 관련비용 반영(안전관리비, 산업안전보건관리비 등)",
    is_checked: "",
    note: "",
  },
  {
    id: 5,
    title: "3. 안전·보건 수준 평가",
    label: "적격 수급업체 선정 가이드라인",
    is_checked: "",
    note: "",
  },
  {
    id: 6,
    title: "4. 안전보건협의체 구성 및 운영",
    label: "안전보건협의체 구성 및 운영(월 1회)",
    is_checked: "",
    note: "",
  },
  {
    id: 7,
    title: "5. 작업장 순회 점검",
    label: "작업장 순회 점검(주 1회 이상)",
    is_checked: "",
    note: "",
  },
  {
    id: 8,
    title: "6. 사업장 합동 안전·보건 점검",
    label: "사업장 합동 안전·보건 점검 실시(분기별 1회 이상)",
    is_checked: "",
    note: "",
  },
  {
    id: 9,
    title: "7. 위험성 평가 및 유해·위험요인 개선",
    label: "위험성 평가 및 유해·위험요인 개선 조치 여부",
    is_checked: "",
    note: "",
  },
  {
    id: 10,
    title: "8.  안전·보건교육 지원 및 실시 여부 확인",
    label: "안전·보건교육 장소 및 자료 제공 등 협조(수급인의 요구가 있는 경우)",
    is_checked: "",
    note: "",
  },
  {
    id: 11,
    title: "8.  안전·보건교육 지원 및 실시 여부 확인",
    label: "수급인의 특별안전보건교육 실시 여부 확인(특별안전보건교육 대상 있는 경우)",
    is_checked: "",
    note: "",
  },
  {
    id: 12,
    title: "9. 경보체계 운영과 대피방법 등 훈련",
    label: "경보체계 운영과 대피방법 등 훈련 여부(발파작업, 화재·폭발, 붕괴 등의 경우)",
    is_checked: "",
    note: "",
  },
  {
    id: 13,
    title: "10. 위생(휴게)시설 및 휴게시설 설치 및 이용",
    label: "위생(휴게)시설 및 휴게시설 설치 및 이용 협조 여부",
    is_checked: "",
    note: "",
  },
  {
    id: 14,
    title: "11. 같은 장소 내 도급인과 관계수급인 등 작업시기·내용 등 조정",
    label: "관계 수급인 작업시기·내용 등 조정(같은 장소에서 도급인과 수급인의 작업이 혼재하여 위험 발생할 우려가 있는 경우)",
    is_checked: "",
    note: "",
  },
  {
    id: 15,
    title: "12. 안전·보건에 관한 정보 제공 등",
    label: "안전 및 보건에 관한 정보제공 및 이행 확인(화학물질, 질식, 붕괴 위험의 경우)",
    is_checked: "",
    note: "",
  },
];
